import { BaseServices, HttpMethod } from '@services/base'

export interface IBiometriaSave {
  proposalCode: string
  isFullCaptureFlow: boolean
}

export interface IResponseBiometriaToken {
  biometricToken: string
}

export default async (data: IBiometriaSave) => {
  const pathname = process.env.REACT_APP_BIOMETRICS_DADOS_APP
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  const response = await BaseServices.request<IResponseBiometriaToken>({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}
